export default "./dist/stdassets/images/icons/measure.png";